import { tokenizeColumnKey } from './tokenizeColumnKey'

// Acronyms that render fully uppercase wherever they appear in a column
// header, regardless of position. Verified against real field names in
// the peach backend's openapi/*.yml (apiName, achFileId, maxAPR,
// whitelistedIPs, isCreateAndSendPDF, samlSubjectNameId,
// CardWithPanAndCvv, sftpSSHPeachPrivateKey, ofacServiceId, ...) plus
// common web/fintech terms.
const ACRONYMS = new Set([
  'id',
  'uuid',
  'guid',
  'url',
  'uri',
  'ip',
  'api',
  'ui',
  'ux',
  'sso',
  'saml',
  'jwt',
  'otp',
  'mfa',
  'pin',
  'cvv',
  'pan',
  'ssh',
  'sftp',
  'html',
  'css',
  'js',
  'json',
  'xml',
  'csv',
  'pdf',
  'sms',
  'utc',
  'gmt',
  'faq',
  'kpi',
  'roi',
  'npv',
  'sla',
  'ach',
  'apr',
  'apy',
  'ssn',
  'dob',
  'ein',
  'tin',
  'itin',
  'fico',
  'nsf',
  'dfi',
  'ofac',
  'scra',
  'kyc',
  'aml',
  'iban',
  'swift',
  'bic',
])

const formatWord = (word: string): string => {
  if (ACRONYMS.has(word)) return word.toUpperCase()

  if (word.endsWith('s') && ACRONYMS.has(word.slice(0, -1))) {
    return `${word.slice(0, -1).toUpperCase()}s`
  }

  return word.charAt(0).toUpperCase() + word.slice(1)
}

/**
 * Turns a raw camelCase/snake_case column key into a readable header
 * label: title case (every word capitalized) with any recognized acronym
 * uppercased wherever it appears — "apiVersion" -> "API Version",
 * "borrowerId" -> "Borrower ID", "loanIds" -> "Loan IDs".
 */
export const formatColumnHeader = (columnKey: string): string =>
  tokenizeColumnKey(columnKey).map(formatWord).join(' ')
